<template>
  <div>
    <el-dialog
      title="签约"
      :visible="true"
      width="600px"
      :center="true"
      @close="close">
      <div class="signContent">
        <el-form class="form" label-width="130px" :model="form" :rules="rules" ref="form">
          <el-form-item label="姓名" prop="realName">
            <el-input placeholder="请输入姓名" v-model="form.realName" maxlength="10"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-input placeholder="请输入手机号" v-model="form.mobile"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="idCard">
            <el-input placeholder="请输入身份证号" v-model="form.idCard"></el-input>
          </el-form-item>
        </el-form>
        <div class="agreement">
          <el-checkbox v-model="haveRead">我已知悉并认同</el-checkbox>
          <span class="protal" @click="signVisible = true">《灵活就业合作伙伴协议》</span>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="submit">同意</el-button>
        </span>
      </div>
    </el-dialog>
    <!-- 《灵活就业合作伙伴协议》 -->
    <signAgreement v-if="signVisible" @close="signVisible = false"></signAgreement>
  </div>
</template>

<script>
import validator from '@/utils/validate'
import signAgreement from './signAgreement.vue'
import { signApply } from '@/api/marketPromotion/activeData'

export default {
  components: { signAgreement },
  data () {
    return {
      haveRead: false,
      signVisible: false,
      form: {
        mobile: '',
        realName: '',
        idCard: ''
      },
      rules: {
        mobile: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          { validator: validator.checkPhone, trigger: 'blur' }
        ],
        realName: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
        idCard: [{ required: true, validator: validator.validateIdCard, trigger: 'blur' }]
      }
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    submit () {
       this.$refs.form.validate(async valid => {
        console.log('valid', valid)
        if (!valid) return
        if (!this.haveRead) return this.$message.error('请勾选灵活就业合作伙伴协议')
        signApply({ ...this.form }).then(res => {
          if (res.code !== 200) return
          if (res.result.status !== 1) return this.$message.error('签约失败')
          this.$message.info('签约成功')
          this.close()
        })
       })
    }
  }
}
</script>

<style scoped>
.signContent{
  text-align: center;
}
.form{
  margin-right: 70px;
}
.agreement{
  margin: 24px 0 16px 0;
  cursor: pointer;
}
</style>
